import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import type { IdArgs } from "@circle-react/api/broadcastsApi";
import { broadcastsApi } from "@circle-react/api/broadcastsApi";
import type { LinkClickRow } from "@circle-react-shared/Emails/BroadcastReport/LinkClicksStats/LinkClickStatsTable";
import { useToast } from "@circle-react-shared/uikit/ToastV2";
import type { BroadcastStatusValue } from "../components/Broadcasts/constants";
import { REFETCH_INTERVAL } from "../components/Broadcasts/constants";

interface ResponseData {
  clicked: number;
  complained: number;
  completed_at: string;
  delivered: number;
  first_delivery_at: string;
  hard_bounced: number;
  id: number;
  internal_name: string;
  link_clicks: Array<LinkClickRow>;
  opened: number;
  recipient_count: number;
  sent: number;
  status: BroadcastStatusValue;
  subject: string;
  unsubscribed: number;
}

export const getBroadcastReportQueryKey = (id: number) => [
  "broadcasts",
  id,
  "report",
];

export const useGetBroadcastReport = ({ id }: IdArgs) => {
  const toastr = useToast();

  return useQuery<ResponseData>({
    queryKey: getBroadcastReportQueryKey(id),
    queryFn: () => broadcastsApi.report({ id }),
    onError: () => toastr.error(t("error")),
    refetchInterval: REFETCH_INTERVAL,
  });
};
